<script setup>
import CustomLink from '@/components/CustomLink.vue';
import { helpCenterURL } from '@/data/shared-faqs';
import MenuLinks from '@/components/MenuLinks.vue';
import LogoMenu from '@/components/menu/LogoMenu.vue';
import { useWayfinding } from '@/composables/wayfinding';

const { desktopDisplayLinks } = useWayfinding();

const emits = defineEmits(['click', 'toggleAccordion']);

function handleLinkClick(args) {
  emits('click', args);
}

function trackAccordionEvent(details) {
  emits('toggleAccordion', details);
}
</script>

<template>
  <div :class="$style['desktop-sidebar']">
    <div :class="$style['desktop-menu']">
      <div>
        <LogoMenu />
        <MenuLinks
          v-for="link in desktopDisplayLinks"
          :key="link.title()"
          :links="link"
          :class="$style['menu-links']"
          force-dropdown
          @linkClicked="handleLinkClick"
          @toggleAccordion="trackAccordionEvent"
        />
      </div>
      <div>
        <CustomLink
          :url="helpCenterURL"
          target="_blank"
          :class="$style['help-center']"
          :text="$t('common.helpCenter')"
        />
      </div>
    </div>
  </div>
</template>

<style>
body .p-sidebar .p-sidebar-content {
  padding: 0;
}
</style>
<style lang="less" module>
.desktop-sidebar {
  border-right: 1px solid @color-grey-200;
  background-color: @color-grey-50;
  font-family: @regular-font;
  font-size: @font-size-15;
  height: 100vh;
  width: @wayfinding-desktop-sidebar-width;
  z-index: 3;
  overflow-y: auto;
  pointer-events: all;
  padding: 1.25rem 1rem;
  @media only screen and (max-width: @wayfinding-tablet-width) {
    display: none;
  }
}
.desktop-sidebar::-webkit-scrollbar {
  display: none;
}

.desktop-sidebar:hover .desktop-sidebar:active {
  overflow-y: auto;
}

.desktop-menu {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  .menu-links {
    padding-top: 1rem;
  }
}

.help-center {
  display: inline-block;
  padding: 0 0 0.855rem 1.5rem;
  color: @cc-light-brown;
  text-decoration: underline;
}
</style>
